import { render, staticRenderFns } from "./StandupContent.vue?vue&type=template&id=1a0b38e3&scoped=true&"
import script from "./StandupContent.vue?vue&type=script&lang=js&"
export * from "./StandupContent.vue?vue&type=script&lang=js&"
import style0 from "./StandupContent.vue?vue&type=style&index=0&id=1a0b38e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b38e3",
  null
  
)

export default component.exports